import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

/**
 * Abstract modal with form component
 * @description Utility class with methods for apply translation to input element of class that extends it
 */
export abstract class AbstractModalWithFormComponent {
  constructor(protected translateService: TranslateService, private translateKey: string, private errorTranslateKey?: string) {
    this.errorTranslateKey = errorTranslateKey || translateKey;
  }

  /**
   * @ignore
   */
  updateTranslateKey(newKey: string): void {
    if (this.errorTranslateKey === this.translateKey) {
      this.errorTranslateKey = newKey;
    }
    this.translateKey = newKey;
  }

  updateErrorTranslateKey(newKey: string): void {
    this.errorTranslateKey = newKey;
  }

  /**
   * Translate specified text with values
   * @param key the key used for translation
   * @param values the values to pass to translation if required
   */
  translate(key: string, values?: Object): string {
    return this.privateTranslate(false, key, values);
  }

  /**
   * @ignore
   */
  private privateTranslate(error: boolean, key: string, values?: Object): string {
    return this.translateService.instant(`${(error ? this.errorTranslateKey : this.translateKey)}.${key}`, values);
  }

  /**
   * Show error on a specified form control
   * @param inputKey form control
   * @param status http status
   * @param errorKey the key used for translation
   * @param errorValue the values to pass to translation if required
   */
  showErrorOnControl(inputKey: AbstractControl | null, status: number, errorKey: string, errorValue?: { [key: string]: string }): void {
    if (status !== 0 && !status.toString().startsWith('5') && inputKey) {
      inputKey.setErrors({
        serverError: this.privateTranslate(true, errorKey, errorValue),
      });
    }
  }
}
